export var AlertType;
(function (AlertType) {
    AlertType["securityThreatParts"] = "securityThreatParts";
    AlertType["screenDetection"] = "screenDetection";
    AlertType["plateComparison"] = "plateComparison";
    AlertType["plateCaseCheck"] = "plateCaseCheck";
    AlertType["missingPlate"] = "missingPlate";
    AlertType["uniqueVehicle"] = "uniqueVehicle";
    AlertType["gpsLocation"] = "gpsLocation";
    AlertType["missingVin"] = "missingVin";
    AlertType["undecodeableVin"] = "undecodeableVin";
    AlertType["vinCaseCheck"] = "vinCaseCheck";
    AlertType["wrongVin"] = "wrongVin";
    AlertType["missingOdometer"] = "missingOdometer";
    AlertType["GPSPermissionsAccepted"] = "GPSPermissionsAccepted";
    AlertType["qualityDetection"] = "qualityDetection";
    AlertType["vehicleDetection"] = "vehicleDetection";
    AlertType["orientationDetection"] = "orientationDetection";
    AlertType["notSupportWebGL"] = "notSupportWebGL";
    AlertType["vlcPreviousDamage"] = "vlcPreviousDamage";
    AlertType["vlcMileage"] = "vlcMileage";
    AlertType["realTime"] = "realTime";
})(AlertType || (AlertType = {}));
